import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const CheckoutFlightSummaryMetaPageTranslationsPageProvider = createTranslationsPageProvider({
  flightResults: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-flights-results/translations/${brand}/${locale}/default.js`),
  checkout: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-checkout/translations/${brand}/${locale}/default.js`),
  prime: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-prime/translations/${brand}/${locale}/default.js`),
  prebookingAttract: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-prebooking-attract/translations/${brand}/${locale}/flights_results-page.js`)
});